import React from "react";
import { useSupplierModel } from "../supplierModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useSupplierModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Supplier Management"]}</span>
    </>
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "供应商名称",
            placeholder: Locale["Supplier Name"],
            fieldName: "name",
            size: "small",
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "联系人",
            placeholder: Locale["Contact"],
            fieldName: "contact",
            size: "small",
        },
        {
            type: SearchTypeEnum.Input,
            span: 4,
            // placeholder: "联系电话",
            placeholder: Locale["Contact Number"],
            fieldName: "phone",
            size: "small",
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            // placeholder: "状态",
            placeholder: Locale["Status"],
            fieldName: "enable",
            size: "small",
            options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
        }
    ]
    return (
        <YhPageHeader
            // title="供应商管理"
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}